// src/utils/newsHelpers.js

export const sortNewsByLatest = (news = []) => {
  return [...news].sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getLatestNews = (news = [], limit = 10) => {
  return sortNewsByLatest(news).slice(0, limit);
};

export const formatNewsDate = (dateString, isArabic = false) => {
  const date = new Date(dateString);

  return date.toLocaleDateString(isArabic ? "ar-SA" : "en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};